import React, { useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-4";
import { useSnackbar } from "notistack";
import {
  Typography,
  Link,
  CircularProgress,
  Backdrop,
  Container,
  Button,
  Stack,
  Toolbar,
} from "@mui/material";
import { db } from "../firebase";
import {
  collection,
  query,
  orderBy,
  limit,
  or,
  getDocs,
  where,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import ProjectCard from "./ProjectCard";
import AddBoxIcon from "@mui/icons-material/AddBox";

function Projects({ user }) {
  const navigate = useNavigate();
  console.log("Profile page");
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(true);
  const [isReady, setIsReady] = React.useState(false);
  const [projects, setProjects] = React.useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log(user);
        const q = query(
          collection(db, "projects"),
          or(
            where("uid", "==", user.uid),
            where("allowed_emails", "array-contains", user.email),
          ),
          orderBy("Created Date", "desc"), // Replace 'Created By' with your timestamp field
          limit(5),
        );
        const querySnapshot = await getDocs(q);
        const projs = [];
        querySnapshot.forEach((doc) => {
          projs.push({ id: doc.id, ...doc.data() });
        });
        console.log(projs);
        setProjects(projs);
      } catch (err) {
        enqueueSnackbar(err.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (isLoading === true && user !== null && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  }); 

  const onOpen = (id) => {
    const proj = projects.find((f) => f.id === id);
    navigate(`/project/${id}/dashboard`, { state: { passProject: proj } });
  };

  return isLoading ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <Scrollbars
      autoHide
      autoHideTimeout={10}
      style={{ width: "100%", height: "100%" }}
    >
      <Toolbar />
      <Container
        maxWidth="md"
        style={{
          // paddingTop: 30,
          paddingBottom: 30,
          // paddingBottom: theme.spacing(4),
          justifyContent: "center",
        }}
      >
        <Stack
          style={{ paddingTop: 50 }}
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Button
            variant="contained"
            onClick={() =>
              navigate(
                "/Feature?id=new&formdisabled=false&tablename=projects&fk_id=none",
              )
            }
            startIcon={<AddBoxIcon />}
          >
            New Project
          </Button>
        </Stack>

        {projects.length === 0
          ? [
              <Typography
                style={{ textAlign: "center" }}
                variant="h5"
                gutterBottom
              >
                {`No projects found.`}
              </Typography>,
              <Stack
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Link
                  href="/Feature?id=new&formdisabled=false&tablename=projects&fk_id=none"
                  color="inherit"
                >
                  {"Create your first project now."}
                </Link>
              </Stack>,
            ]
          : projects.map((project, idx) => (
              <ProjectCard key={idx} project={project} open={onOpen} />
            ))}
      </Container>
    </Scrollbars>
  );
}

export default Projects;
